import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { BRAND, GRAY, ACCENT, GOOGLE } from "../colors";

export const ReplyPostedAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const cardAppear = spring({ frame, fps, config: { damping: 14 } });
  const replySlide = spring({ frame: frame - 40, fps, config: { damping: 12 } });
  const successPop = spring({ frame: frame - 70, fps, config: { damping: 10, stiffness: 120 } });

  return (
    <AbsoluteFill
      style={{
        backgroundColor: GRAY[50],
        justifyContent: "center",
        alignItems: "center",
        padding: 30,
      }}
    >
      <div
        style={{
          transform: `scale(${cardAppear})`,
          opacity: cardAppear,
          width: "100%",
          maxWidth: 480,
          backgroundColor: "white",
          borderRadius: 20,
          padding: 24,
          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
        }}
      >
        {/* Google Business header */}
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 8,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 20,
              fontWeight: 800,
              background: `linear-gradient(135deg, ${GOOGLE.blue}, ${GOOGLE.green})`,
              color: "white",
            }}
          >
            G
          </div>
          <div>
            <div style={{ fontSize: 19, fontWeight: 700, color: GRAY[800] }}>Google Business Profile</div>
            <div style={{ fontSize: 14, color: GRAY[400] }}>Bella&apos;s Kitchen · Portland, OR</div>
          </div>
        </div>

        {/* Review */}
        <div
          style={{
            padding: "16px 18px",
            backgroundColor: GRAY[50],
            borderRadius: 14,
            marginBottom: 6,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                backgroundColor: "#E8D44D",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 15,
                fontWeight: 700,
                color: "white",
              }}
            >
              JD
            </div>
            <div>
              <div style={{ fontSize: 17, fontWeight: 600, color: GRAY[800] }}>John D.</div>
              <div style={{ fontSize: 16, color: "#F59E0B" }}>★★★★★</div>
            </div>
          </div>
          <div style={{ fontSize: 17, color: GRAY[600], lineHeight: 1.4 }}>
            &quot;Best brunch spot in Portland! The eggs benedict was perfect and the outdoor
            patio is beautiful.&quot;
          </div>
        </div>

        {/* Reply (slides in) */}
        <div
          style={{
            opacity: replySlide,
            transform: `translateY(${interpolate(replySlide, [0, 1], [15, 0])}px)`,
            padding: "16px 18px",
            paddingLeft: 28,
            borderLeft: `3px solid ${BRAND[400]}`,
            marginLeft: 18,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: GRAY[800] }}>Owner response</div>
            <div style={{ fontSize: 13, color: GRAY[400] }}>Just now</div>
          </div>
          <div style={{ fontSize: 17, color: GRAY[600], lineHeight: 1.4 }}>
            Thank you for visiting Bella&apos;s Kitchen, John! Our Portland patio is a local favorite, and we&apos;re thrilled you loved the eggs benedict. See you at brunch soon!
          </div>
        </div>

        {/* Success badge */}
        {frame >= 70 && (
          <div
            style={{
              marginTop: 20,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                transform: `scale(${successPop})`,
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                backgroundColor: ACCENT[100],
                color: ACCENT[600],
                padding: "8px 18px",
                borderRadius: 22,
                fontSize: 16,
                fontWeight: 700,
              }}
            >
              <div
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  backgroundColor: ACCENT[500],
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 13,
                }}
              >
                ✓
              </div>
              Reply posted successfully
            </div>
          </div>
        )}
      </div>
    </AbsoluteFill>
  );
};
